import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaAnamnesiSocialeEditComponent.vue?vue&type=template&id=54683f21"
import script from "./RsaSchedaRelazioneSanitariaAnamnesiSocialeEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaAnamnesiSocialeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports